// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module__chatWindows{width:320px;height:100%;position:fixed;display:flex;flex-direction:column}
`, "",{"version":3,"sources":["webpack://./components/ui/chat-windows/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,WAAY,CACZ,WAAY,CACZ,cAAe,CACf,YAAa,CAEb,qBAAsB","sourcesContent":[".chatWindows {\n  width: 320px;\n  height: 100%;\n  position: fixed;\n  display: flex;\n  // flex-wrap: wrap;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatWindows": `styles-module__chatWindows`
};
export default ___CSS_LOADER_EXPORT___;
